import React, { Fragment } from 'react';
import { DynamicFieldsType } from '@philips-internal/oswald-ui-constants';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { getLostProps, isContentfulString, isFunction, propagateData } from '@philips-internal/oswald-ui-utils';
import { NotFound } from '../not-found/not-found.js';
import { DynamicFieldsProperties } from './dynamic-fields-types.js';
import { getFieldOrFieldset, jsonLogicEval, resolveConditions } from './dynamic-fields-utils.js';
function DynamicFields(props) {
    let formulas = [];
    let visualData = {};
    const addFormula = (entry, formula) => {
        formulas = [
            ...formulas,
            {
                entry,
                exp: formula,
            },
        ];
    };
    const addVisualData = (entry, label) => {
        visualData = {
            ...visualData,
            [entry]: label,
        };
    };
    const onFieldChange = ({ entry, value, oldValue }) => {
        if (!isContentfulString(entry)) {
            return;
        }
        formulaEval(entry, value);
        props.onChange(new ChangeEvent({ entry, oldValue, value }));
    };
    const formulaEval = (entry, value) => {
        for (const formula of formulas) {
            const result = jsonLogicEval(formula.exp, { ...props.data, [entry]: value });
            if (!result || !isFunction(props.onChange)) {
                continue;
            }
            props.onChange(new ChangeEvent({
                entry: formula.entry,
                oldValue: props.data[formula.entry],
                value: result,
            }));
        }
    };
    const lostProps = getLostProps(DynamicFieldsProperties, props);
    const shouldMapComponents = props.metaData && props.metaData.children && props.metaData.componentType === DynamicFieldsType.DYNAMIC_FIELDS;
    const components = shouldMapComponents
        ? props.metaData.children.map((child) => getFieldOrFieldset({
            addFormula,
            addVisualData,
            child,
            data: props.data,
            onBlur: props.onBlur,
            onFocus: props.onFocus,
            visible: resolveConditions(child, props.data),
        }))
        : React.createElement(NotFound, null);
    const data = {
        ...props.data,
        ...visualData,
    };
    const inheritedProps = {
        ...lostProps,
        alwaysShowLabel: true,
        onChange: onFieldChange,
    };
    return (React.createElement(Fragment, null, propagateData(components, data, inheritedProps)));
}
export { DynamicFields, };
//# sourceMappingURL=dynamic-fields.js.map